/* eslint-disable no-dupe-keys */
import { keyframes } from "@emotion/react";

import { svg } from "config/svgStyles";

export const reviewOrderPage = ({ isDesktop }) => ({
  width: "100%",
  background: "white",
  height: "100%",
  overflow: isDesktop ? "hidden" : "auto",
});

export const reviewOrderContainer = ({ isDesktop }) => ({
  width: "100%",
  background: "white",
  overflowY: isDesktop ? "hidden" : "auto",
  overflowX: "hidden",
  maxWidth: "1400px",
  margin: "0 auto",
  height: "100%",
});

export const reviewOrderPanels =
  ({ readyToOrder }) =>
  ({ isDesktop }) => ({
    height: isDesktop ? "100%" : "auto",
    width: isDesktop ? "155%" : "200%",

    display: "grid",
    gridTemplateColumns: isDesktop ? "55fr 45fr 55fr" : "1fr 1fr",
    gridTemplateRows: "auto",

    transition: readyToOrder
      ? "all 0.5s ease-in-out 0.5s"
      : "all 0.3s ease-in-out",
    transform:
      readyToOrder && (isDesktop ? "translateX(-35.5%)" : "translateX(-50%)"),
  });

export const mobileDivider = {
  width: "100%",
};

// * Panel 1 -------------------------------------------------
export const reviewInfoPanel = {};

// * Panel 2 -------------------------------------------------
export const reviewOverviewPanel = {
  overflow: "auto",
};

// * Panel 3 -------------------------------------------------
export const reviewFinalPanel = {};

//
export const reviewInfoPanelContent = ({ isDesktop, isTablet }) => ({
  padding: "50px",
  paddingInline: isTablet && "100px",
  paddingInline: isDesktop && "50px",
});

export const reviewOverviewPanelContent = ({ isTablet, isDesktop }) => ({
  padding: "50px",
  paddingInline: isTablet && "100px",
  paddingInline: isDesktop && "50px",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
});

export const reviewFinalPanelContent = ({ isTablet, isDesktop }) => ({
  flexShrink: 0,
  padding: "50px 50px 20px",
  paddingInline: isTablet && "100px",
  paddingInline: isDesktop && "50px",
});

export const reviewOrderRecipe = () => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "20px",
});

export const reviewCopy = () => ({
  fontSize: "14px",
  lineHeight: "18px",
  letterSpacing: "0.05em",

  a: {
    color: "primary",
  },
});

export const reviewActions = {
  margin: "30px 0",
  display: "flex",
  flexDirection: "column",
  borderBottom: "1px solid",
  borderColor: "grey9",
};

export const recipeLoadingIndicator = {
  margin: 0,
  height: "30px",
  width: "30px",
};

export const reviewAction = ({ isMobile }) => ({
  padding: "20px",
  display: "flex",
  alignItems: "center",
  gap: "20px",
  lineHeight: isMobile ? "20px" : "30px",
  borderTop: "1px solid",
  borderColor: "grey9",
  color: "black",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: isMobile ? "20px" : "30px",
  letterSpacing: isMobile ? "0.05em" : "0.025em",
  textTransform: "uppercase",
  fontFamily: "body",
  textAlign: "left",
  width: "100%",
  transition: "color  0.3s",

  "&:hover": {
    color: "primary",
    svg: {
      ...svg("primary"),
    },
  },

  "&:disabled": {
    cursor: " not-allowed",
    color: "grey6",
    svg: {
      ...svg("grey6"),
    },
  },
});

// * Panel 2 -------------------------------------------------
const pulse = keyframes({
  "0%": {
    opacity: "0",
    transform: "translate(25%, 25%)",
  },
  "40%": {
    opacity: ".50",
    transformOrigin: "50% 50%",
    transform: "translate(25%, 20%) rotate(15deg) scale(2.5)",
    transition: "all .3s cubic-bezier(0.6, 0.04, 0.98, 0.335)",
  },
  "100%": {
    opacity: "1",
    transform: "translate(-25%, 20%) rotate(0deg) scale(1)",
  },
});

export const reviewOverviewImageContainer = ({ isDesktop, isMobile }) => ({
  marginTop: "40px",
  minHeight: isDesktop ? "260px" : !isMobile ? "390px" : "280px",
  width: "100%",
  border: "1px solid",
  borderColor: "grey9",
  borderRadius: "20px",
  position: "relative",
});

export const approvedStamp = ({ isDesktop }) => ({
  width: isDesktop ? "194px" : "125px",
  position: "absolute",
  left: 0,
  bottom: 0,
  animation: `${pulse} 0.5s ease-in 0.1s 1 both`,
  zIndex: 50,
});

export const reviewOverviewSpecs = () => ({
  marginTop: "30px",
  paddingBottom: "100px",
});

export const specCustomisation = () => ({
  padding: "10px 0",
  borderBottom: "1px solid",
  borderColor: "grey9",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const specCustomisationName = () => ({
  fontFamily: "dinCondensed",
  fontWeight: "700",
  color: "primary",
  textTransform: "capitalize",
});

export const specsOptionsValues = () => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const specsOptionValue = () => ({
  textTransform: "capitalize",
});

export const specsSubOptionValue = () => ({
  marginTop: "10px",
  paddingLeft: "20px",
});
